import Button from 'components/generic-components/thera-start-components/Button';
import { FaCheck } from 'react-icons/fa';
import { GoArrowLeft } from 'react-icons/go';

export default function OperatingAgreementStep({ formik, onNext, onBack }) {
  return (
    <div className="relative flex flex-col items-center justify-center bg-[#181818] px-4 py-8">
      {/* Back button OUTSIDE the card, top-right or left depending on your need */}
      <div className="max-w-1xl w-full">
        <button
          type="button"
          onClick={onBack}
          className="mb-2 flex items-center gap-2 font-semibold text-white transition-colors hover:text-blue-500"
        >
          <GoArrowLeft size={18} />
          <span>Back</span>
        </button>
      </div>

      {/* Card */}
      <div className="max-w-1xl mx-auto mt-4 flex min-h-[32rem] w-full flex-col justify-between rounded-2xl bg-white p-6 shadow-xl sm:p-8 md:p-10">
        {/* Card Content */}
        <div>
          <p className="mb-2 text-[1.50rem] font-[600] text-dark">Trademark your company</p>
          <p className="mb-4 text-[#0000007A]">
            Get a domain name, website, email address, and phone number for your business in minutes.
          </p>

          <div className="mb-2 flex items-center justify-between">
            <span className="font-semibold text-dark">Trademark Services</span>
            <span className="font-bold text-[#2571CF]">$499</span>
          </div>

          <span className="font-semibold text-[#191919BF]">One time</span>
          <hr className="mb-4 text-[#00000026]" />

          <div className="mb-4">
            <div className="mb-2 text-[0.9rem] text-dark">WHAT TO KNOW</div>
            <ul className="mb-4 text-[#191919CC]">
              <li className="mb-[1rem] flex items-start font-sans text-[0.875rem] text-light-gray sm:text-[1rem]">
                <span className="mr-[1rem] flex size-5 shrink-0 items-center justify-center rounded-full bg-[#F2F2F2] pb-[0.25rem]">
                  <FaCheck className="mt-1 size-3 text-dark" />
                </span>
                <span className="text-dark-gray">
                  They'll offer advice as needed, complete and file your federal registration application, keep track of
                  deadlines, and respond to procedural office actions.
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="mt-4 flex flex-col gap-3">
          <Button
            className="w-full rounded-lg !bg-black py-3 text-[1rem] font-semibold !text-white transition-colors hover:bg-gray-900"
            onClick={() => {
              formik.setFieldValue('operatingAgreement', true);
              onNext();
            }}
          >
            Add Trademark Service
          </Button>

          <Button
            variant="white"
            className="w-full rounded-lg border border-black bg-white py-3 text-[1rem] font-semibold text-black transition-colors hover:bg-gray-100"
            onClick={() => {
              formik.setFieldValue('operatingAgreement', false);
              onNext();
            }}
          >
            Skip
          </Button>
        </div>
      </div>
    </div>
  );
}
